<template>
  <div class="container-fluid pt-5 mt-5">
    <div class="row">
      <div class="col-sm-4 mb-3">
        <UserNav />
      </div>
      <div class="col-sm-8">
        <div class="card">
          <div
            class="d-flex justify-content-between p-2 text-center"
            style="background-color: #F69325 ; color: #fff"
          >
            <h4>Personal Information</h4>

            <i
              class="fa fa-pencil p-2"
              role="button"
              @click="EditProfile()"
              v-if="editProfile == false"
            ></i>
            <i
              class="fa fa-minus p-2"
              @click="EditProfile()"
              role="button"
              v-if="editProfile == true"
            ></i>
          </div>
          <div class="row p-3 mb-3">
            <div class="col-sm-4 p-3">
              <label for="">Name</label>
              <input
                type="text"
                v-model="customer.name"
                class="form-control"
                readonly
              />
            </div>
            <div class="col-sm-4 p-3">
              <label for="">Email</label>
              <input
                type="text"
                v-model="customer.email"
                class="form-control"
                readonly
              />
            </div>
            <div class="col-sm-4 p-3">
              <label for="">Number</label>
              <input
                type="text"
                v-model="customer.number"
                class="form-control"
                readonly
              />
            </div>
          </div>
          <div
            class="d-flex justify-content-between p-2 text-center"
            style="background-color: #F69325 ; color: #fff"
          >
            <h4>Address</h4>
            <i
              class="fa fa-plus p-2"
              role="button"
              @click="addShowadd()"
              v-if="addShow == false"
            ></i>
            <i
              class="fa fa-minus p-2"
              @click="addShowadd()"
              role="button"
              v-if="addShow == true"
            ></i>
          </div>
          <div class="row p-3" v-if="customerAdr.length == 0">
            <div class="col-sm-12 text-center">Address Not Found</div>
          </div>
          <div
            class="row p-3"
            v-for="(address, index) in customerAdr"
            :key="index"
          >
            <div class="col-sm-8">
              <div class="p-1">
                <span
                  class="badge"
                  style="background-color: #F69325 ; color: #fff"
                  >{{ address.addressType }}</span
                >
              </div>
              <div class="p-1">
                <span
                  ><strong>{{ address.c_person }}</strong></span
                >&nbsp;&nbsp;&nbsp;&nbsp;
                <span>{{ address.c_number }}</span>
              </div>
              <div class="p-1">
                <span>
                  {{ address.firstLine }},{{ address.secondLine }},{{
                    address.landmark
                  }},{{ address.city }},{{ address.state }},{{
                    address.pincode
                  }}
                </span>
              </div>
            </div>
            <div class="col-sm-4 text-center">
              <i
                class="fa fa-edit p-3"
                style="color: #F69325 "
                @click="addEditShow(++index, address.id)"
                role="button"
              ></i>
              <i
                class="fa fa-trash p-3"
                style="color: red"
                @click="addDelete(address.id)"
                role="button"
              ></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- other hidden items -->
    <div>
      <b-modal v-model="addShow" size="lg" title="Add Address" hide-footer>
        <div>
          <div class="container">
            <h5 class="text-center">Move marker to adjust your Location</h5>
          </div>
          <gmap-map
            :center="center"
            :zoom="12"
            style="width:100%;  height: 400px;"
          >
            <div v-if="marker">
              <gmap-marker
                :position="marker.position"
                @click="center = marker.position"
                :draggable="true"
                :clickable="true"
                @drag="updateLocation"
                @dragend="drgensed"
              ></gmap-marker>
            </div>
          </gmap-map>
          <!-- <div class="container pt-4 pb-4">
              <p class="text-center text-primary text-bold">{{ selectedAddress }}</p>

              <button class="btn btn-success btn-block" type="button" disabled v-if="addAddressloading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Loading...
              </button>

              <button class="btn btn-success btn-block" @click="AddAddress" v-else>Save</button>
          </div> -->

          <div class="pt-4" v-show="selectedAddress">
            <b-form class="row" v-on:submit.prevent="AddAddress">
              <div class="col-md-12">
                <b-form-group label="Address Type:">
                  <b-form-select
                    v-model="address.addressType"
                    :options="addType"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Contact Person:">
                  <b-form-input
                    v-model="address.c_person"
                    type="text"
                    required
                    placeholder="Enter Name of Contact Person"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Mobile Number:">
                  <b-form-input
                    v-model="address.c_number"
                    type="number"
                    required
                    placeholder="10-digit mobile number"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Pincode:">
                  <b-form-input
                    v-model="address.pincode"
                    type="number"
                    required
                    placeholder="Pincode"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="landmark:">
                  <b-form-input
                    v-model="address.landmark"
                    type="text"
                    placeholder="LandMark"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Addrees First Line:">
                  <b-form-input
                    type="text"
                    v-model="address.firstLine"
                    placeholder="Flat No / Society / Tower"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="Addrees Second Line:">
                  <b-form-input
                    type="text"
                    v-model="address.secondLine"
                    placeholder="Address (Area and Street)"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group label="City:">
                  <b-form-input
                    v-model="address.city"
                    type="text"
                    required
                    placeholder="City / District / Town "
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-sm-6">
                <b-form-group label="State:">
                  <b-form-select
                    v-model="address.state"
                    :options="statelist"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 text-center">
                <button type="submit" class="btn btn-success">
                  Save
                </button>
              </div>
            </b-form>
          </div>
        </div>
      </b-modal>
      <b-modal v-model="editAddress" size="lg" title="Edit Address" hide-footer>
        <div v-if="updateAddressloading">
          <sweetalert-icon class="text-center" :icon="Loadingtype" />
        </div>
        <b-form class="row" v-on:submit.prevent="UpdateAddress" v-else>
          <div class="col-md-12">
            <b-form-group label="Address Type:">
              <b-form-select
                v-model="editaddressdata.addressType"
                :options="addType"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Contact Person:">
              <b-form-input
                v-model="editaddressdata.c_person"
                type="text"
                required
                placeholder="Enter Name of Contact Person"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Mobile Number:">
              <b-form-input
                v-model.number="editaddressdata.c_number"
                type="number"
                required
                placeholder="10-digit mobile number"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Pincode:">
              <b-form-input
                v-model.number="editaddressdata.pincode"
                type="number"
                required
                placeholder="Pincode"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="landmark:">
              <b-form-input
                v-model="editaddressdata.landmark"
                type="text"
                placeholder="LandMark"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Addrees First Line:">
              <b-form-input
                type="text"
                v-model="editaddressdata.firstLine"
                placeholder="Flat No / Society / Tower"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Addrees Second Line:">
              <b-form-input
                type="text"
                v-model="editaddressdata.secondLine"
                placeholder="Address (Area and Street)"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="City:">
              <b-form-input
                v-model="editaddressdata.city"
                type="text"
                required
                placeholder="City / District / Town "
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="State:">
              <b-form-select
                v-model="editaddressdata.state"
                :options="statelist"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-6 ">
            <button type="submit" class="btn btn-success">
              Update Address
            </button>
          </div>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
import { mapGetters } from "vuex";
import UserNav from "@/components/UserNav.vue";
import axios from "axios";

export default {
  data: () => {
    return {
      center: { lat: 28.5355, lng: 77.391 },
      marker: null,
      selectedAddress: null,
      updateAddressloading: false,
      updateProfileloading: false,
      addAddressloading: false,
      Loadingtype: "loading",
      addShow: false,
      editProfile: false,
      editAddress: false,
      statelist: [
        {
          value: null,
          text: "Select State"
        },
        {
          value: "Delhi NCR",
          text: "Delhi NCR"
        }
      ],
      addType: [
        {
          value: null,
          text: "Select Address Type"
        },
        {
          value: "Home",
          text: "Home"
        },
        {
          value: "Office/Commercial	",
          text: "Office/Commercial	"
        }
      ],
      editaddressdata: {},
      editaddressindex: 0,
      address: {
        addressType: null,
        c_number: "",
        c_person: "",
        city: "",
        firstLine: "",
        landmark: "",
        status: true,
        latlng: { lat: 0, lng: 0 },
        pincode: "",
        secondLine: "",
        state: null
      },
      customer: {
        defaultAddress: "",
        email: "",
        name: "",
        number: ""
      },
      customerAdr: []
    };
  },
  components: {
    UserNav
  },
  computed: {
    ...mapGetters({
      Luser: "getUser"
    })
  },
  mounted() {
    this.setupFirebaseReading();
    this.geolocate();
  },
  methods: {
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        const marker = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.marker = { position: marker };
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };

        this.getReverseGeoCode();
      });
    },
    updateLocation(location) {
      const updatedMarker = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };

      this.marker = {
        ...this.marker,
        position: updatedMarker
      };
    },
    drgensed() {
      this.center = this.marker.position;
      this.getReverseGeoCode();
    },
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind("customer", dbFs.collection("customer").doc(this.Luser.uid))
        .then(() => {
          this.getCustomerAdr();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCustomerAdr() {
      this.$bind(
        "customerAdr",
        dbFs
          .collection("customer")
          .doc(this.Luser.uid)
          .collection("address")
          .where("status", "==", true)
      )
        .then(() => {
          console.log(this.customerAdr);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addShowadd() {
      this.addShow = !this.addShow;
    },
    EditProfile() {
      this.editProfile = !this.editProfile;
    },
    AddAddress() {
      this.addAddressloading = true;
      let add = this.address;
      dbFs
        .collection("customer")
        .doc(this.Luser.uid)
        .collection("address")
        .add(add)
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.Loadingtype = "success";
          this.address = {
            addressType: null,
            c_number: "",
            c_person: "",
            city: "",
            firstLine: "",
            status: true,
            landmark: "",
            latlng: { lat: 0, lng: 0 },
            pincode: "",
            secondLine: "",
            state: null
          };

          this.$root.toast("Address added successfully");
          // setTimeout(() => {
          this.addShow = !this.addShow;
          this.addAddressloading = false;
          // }, 500);
        });
    },
    addDelete(id) {
      dbFs
        .collection("customer")
        .doc(this.Luser.uid)
        .collection("address")
        .doc(id)
        .set(
          {
            status: false
          },
          { merge: true }
        )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    addEditShow(index, id) {
      let i = --index;
      this.editaddressdata = this.customerAdr[i];
      this.editaddressindex = id;
      this.editAddress = !this.editAddress;
    },
    UpdateAddress() {
      this.updateAddressloading = true;
      let id = this.editaddressindex;
      let add = this.editaddressdata;
      dbFs
        .collection("customer")
        .doc(this.Luser.uid)
        .collection("address")
        .doc(id)
        .set(add)
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.Loadingtype = "success";
          this.editaddressdata = {};
          setTimeout(() => {
            this.editAddress = !this.editAddress;
            this.updateAddressloading = false;
          }, 3000);
        });
    },
    UpdateProfile() {
      this.updateProfileloading = true;
      let data = {
        name: this.customer.name,
        email: this.customer.email,
        number: this.customer.number
      };
      dbFs
        .collection("customer")
        .doc(this.Luser.uid)
        .set(data, { merge: true })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.Loadingtype = "success";
          setTimeout(() => {
            this.editProfile = !this.editProfile;
            this.updateProfileloading = false;
          }, 3000);
        });
    },
    getReverseGeoCode() {
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${
        this.marker.position.lat
      },${
        this.marker.position.lng
      }&sensor=true&key=AIzaSyABMQJLZkns8-CdR0zwdYw6Fm8a7FRBjpI`;

      this.address.latlng = {
        lat: this.marker.position.lat,
        lng: this.marker.position.lng
      };

      axios
        .get(url)
        .then(res => {
          const addressComp = res.data.results[0].address_components;
          this.address = {
            ...this.address,
            firstLine:
              addressComp[0].long_name + " " + addressComp[1].long_name,
            state: addressComp[addressComp.length - 3].long_name,
            pincode: addressComp[addressComp.length - 1].long_name,
            city: addressComp[addressComp.length - 5].long_name
          };
          this.selectedAddress = res.data.results[0].formatted_address;
        })
        .catch(err => {
          console.log(err);
        });
      this.$refs["my-modal"].hide();
    }
  }
};
</script>

<style>
.list-group-item.active {
  background-color: #51381b !important;
  border-color: #51381b;
}
</style>
